export default "__VITE_ASSET__jzdHkTaa__"